import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { useMemo } from 'react';
import './SensorCard.css';

const CHANNEL_COLORS = { ch1: '#8884d8', ch2: '#82ca9d', ch3: '#ffc658' };

const SensorCard = ({ sensor }) => {
  const { sensorId, sensorVersion, current, trend } = sensor;

  const hasMultiChannel = useMemo(() => {
    return (trend || []).some(item => item.ch2 != null || item.ch3 != null);
  }, [trend]);

  const chartData = (trend || []).map(item => ({
    time: new Date(item.timestamp).toLocaleTimeString('ko-KR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }),
    ch1: item.ch1,
    ...(hasMultiChannel ? { ch2: item.ch2, ch3: item.ch3 } : {}),
  }));

  return (
    <div className="sensor-card">
      <div className="sensor-card-header">
        <span className="sensor-id">Sensor {sensorId}</span>
        {sensorVersion && <span className="sensor-version">v{sensorVersion}</span>}
      </div>
      <div className="sensor-current-values">
        <div className={`channel-value ch1 ${!hasMultiChannel ? 'single' : ''}`}>
          <span className="label">{hasMultiChannel ? 'CH1' : 'Current'}</span>
          <span className="value">{current?.ch1?.toFixed(3) ?? '-'}</span>
          <span className="unit">kW</span>
        </div>
        {hasMultiChannel && (
          <>
            <div className="channel-value ch2">
              <span className="label">CH2</span>
              <span className="value">{current?.ch2?.toFixed(3) ?? '-'}</span>
              <span className="unit">kW</span>
            </div>
            <div className="channel-value ch3">
              <span className="label">CH3</span>
              <span className="value">{current?.ch3?.toFixed(3) ?? '-'}</span>
              <span className="unit">kW</span>
            </div>
          </>
        )}
      </div>
      <div className="sensor-trend-chart">
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={200}>
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#333" />
              <XAxis
                dataKey="time"
                stroke="#888"
                tick={{ fontSize: 10 }}
                interval="preserveStartEnd"
              />
              <YAxis stroke="#888" tick={{ fontSize: 10 }} />
              <Tooltip
                contentStyle={{
                  backgroundColor: '#1a1a2e',
                  border: '1px solid #2a2a4a',
                  color: '#e2e4e8',
                }}
              />
              <Legend />
              <Line type="monotone" dataKey="ch1" stroke={CHANNEL_COLORS.ch1}
                    name={hasMultiChannel ? 'CH1' : 'Current'} strokeWidth={2} dot={false} />
              {hasMultiChannel && (
                <Line type="monotone" dataKey="ch2" stroke={CHANNEL_COLORS.ch2}
                      name="CH2" strokeWidth={2} dot={false} />
              )}
              {hasMultiChannel && (
                <Line type="monotone" dataKey="ch3" stroke={CHANNEL_COLORS.ch3}
                      name="CH3" strokeWidth={2} dot={false} />
              )}
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <div className="no-data">데이터 없음</div>
        )}
      </div>
    </div>
  );
};

export default SensorCard;
